// Costanti e helper condivisi del modulo "Assistenza ordine".
import {
  Undo2, AlertTriangle, PackageX, Truck, ScanSearch, HelpCircle,
  Clock, MessageSquare, Handshake, CheckCircle2, XCircle, ShieldCheck,
  BadgeEuro, Ban, RotateCcw, LifeBuoy,
} from 'lucide-react';
import { getAdminAuthHeader } from './adminFetch';

export const API_URL = process.env.REACT_APP_BACKEND_URL;
export const CASES_API = `${API_URL}/api/order-cases`;
export const ADMIN_CASES_API = `${API_URL}/api/admin/order-cases`;

export const CASE_TYPE_META = {
  RETURN: { label: 'Richiesta di reso', short: 'Reso', Icon: Undo2, accent: 'text-teal-700', bg: 'bg-teal-50', ring: 'ring-teal-200' },
  DEFECTIVE: { label: 'Prodotto difettoso', short: 'Difettoso', Icon: AlertTriangle, accent: 'text-amber-700', bg: 'bg-amber-50', ring: 'ring-amber-200' },
  DAMAGED: { label: 'Prodotto danneggiato', short: 'Danneggiato', Icon: PackageX, accent: 'text-rose-700', bg: 'bg-rose-50', ring: 'ring-rose-200' },
  NON_DELIVERY: { label: 'Problema di consegna', short: 'Consegna', Icon: Truck, accent: 'text-indigo-700', bg: 'bg-indigo-50', ring: 'ring-indigo-200' },
  NON_CONFORMITY: { label: 'Prodotto non conforme', short: 'Non conforme', Icon: ScanSearch, accent: 'text-violet-700', bg: 'bg-violet-50', ring: 'ring-violet-200' },
  OTHER: { label: 'Altro problema', short: 'Altro', Icon: HelpCircle, accent: 'text-slate-700', bg: 'bg-slate-50', ring: 'ring-slate-200' },
};

export const CASE_ACTION_LABELS = {
  RETURN: 'Richiedi un reso',
  DEFECTIVE: 'Segnala un prodotto difettoso',
  DAMAGED: 'Segnala un prodotto danneggiato',
  NON_DELIVERY: 'Segnala un problema di consegna',
  NON_CONFORMITY: 'Segnala un prodotto non conforme',
  OTHER: 'Altro problema',
};

export const CASE_STATUS_META = {
  OPEN: { label: 'Aperto', cls: 'bg-sky-100 text-sky-800 border-sky-200' },
  WAITING_FOR_SELLER: { label: "In attesa dell'artigiano", cls: 'bg-amber-100 text-amber-800 border-amber-200' },
  WAITING_FOR_BUYER: { label: 'In attesa del cliente', cls: 'bg-blue-100 text-blue-800 border-blue-200' },
  IN_DISCUSSION: { label: 'In conversazione', cls: 'bg-teal-100 text-teal-800 border-teal-200' },
  SOLUTION_PROPOSED: { label: 'Soluzione proposta', cls: 'bg-violet-100 text-violet-800 border-violet-200' },
  WAITING_FOR_ACCEPTANCE: { label: 'Proposta da valutare', cls: 'bg-violet-100 text-violet-800 border-violet-200' },
  SELLER_RESPONSE_OVERDUE: { label: 'Risposta scaduta', cls: 'bg-orange-100 text-orange-800 border-orange-200' },
  ESCALATED_TO_RARIFEX: { label: 'Rarifex coinvolto', cls: 'bg-fuchsia-100 text-fuchsia-800 border-fuchsia-200' },
  RESOLVED: { label: 'Risolto', cls: 'bg-emerald-100 text-emerald-800 border-emerald-200' },
  CLOSED: { label: 'Chiuso', cls: 'bg-slate-100 text-slate-700 border-slate-200' },
  CANCELLED: { label: 'Annullato', cls: 'bg-slate-100 text-slate-500 border-slate-200' },
};

export const RETURN_STATUS_LABELS = {
  NOT_APPLICABLE: 'Nessun reso',
  RETURN_REQUESTED: 'Reso richiesto',
  RETURN_AUTHORIZED: 'Reso autorizzato',
  RETURN_IN_TRANSIT: 'Reso in transito',
  RETURN_DELIVERED: 'Reso ricevuto',
  RETURN_REJECTED: 'Reso non accettato',
};

export const REFUND_STATUS_LABELS = {
  NONE: 'Nessun rimborso',
  REQUESTED: 'Rimborso richiesto',
  PROCESSING: 'Rimborso in corso',
  PARTIALLY_REFUNDED: 'Rimborsato parzialmente',
  REFUNDED: 'Rimborsato',
  FAILED: 'Rimborso non riuscito',
};

export const PROPOSAL_TYPE_META = {
  REPAIR: { label: 'Riparazione', Icon: RotateCcw },
  REPLACEMENT: { label: 'Sostituzione', Icon: ShieldCheck },
  PARTIAL_REFUND: { label: 'Rimborso parziale', Icon: BadgeEuro },
  FULL_REFUND: { label: 'Rimborso totale', Icon: BadgeEuro },
  OTHER: { label: 'Altro accordo', Icon: Handshake },
};

export const PRIORITY_META = {
  LOW: { label: 'Bassa', cls: 'bg-slate-100 text-slate-600' },
  NORMAL: { label: 'Normale', cls: 'bg-sky-100 text-sky-700' },
  HIGH: { label: 'Alta', cls: 'bg-orange-100 text-orange-700' },
  URGENT: { label: 'Urgente', cls: 'bg-red-100 text-red-700' },
};

export const TIMELINE_META = {
  CASE_CREATED: { label: 'Richiesta di assistenza aperta', Icon: LifeBuoy, cls: 'text-teal-600 bg-teal-50' },
  MESSAGE_ADDED: { label: 'Nuovo messaggio', Icon: MessageSquare, cls: 'text-slate-600 bg-slate-100' },
  EVIDENCE_REQUESTED: { label: 'Richiesta di informazioni', Icon: MessageSquare, cls: 'text-blue-600 bg-blue-50' },
  SOLUTION_PROPOSED: { label: 'Soluzione proposta', Icon: Handshake, cls: 'text-violet-600 bg-violet-50' },
  SOLUTION_ACCEPTED: { label: 'Proposta accettata', Icon: CheckCircle2, cls: 'text-emerald-600 bg-emerald-50' },
  SOLUTION_REJECTED: { label: 'Proposta non accettata', Icon: XCircle, cls: 'text-orange-600 bg-orange-50' },
  RETURN_AUTHORIZED: { label: 'Reso autorizzato', Icon: Undo2, cls: 'text-teal-600 bg-teal-50' },
  RETURN_SHIPPED: { label: 'Reso spedito', Icon: Truck, cls: 'text-indigo-600 bg-indigo-50' },
  RETURN_RECEIVED: { label: 'Reso ricevuto', Icon: CheckCircle2, cls: 'text-emerald-600 bg-emerald-50' },
  REFUND_REQUESTED: { label: 'Rimborso richiesto', Icon: BadgeEuro, cls: 'text-amber-600 bg-amber-50' },
  REFUND_SUCCEEDED: { label: 'Rimborso completato', Icon: CheckCircle2, cls: 'text-emerald-600 bg-emerald-50' },
  REFUND_FAILED: { label: 'Rimborso non riuscito', Icon: AlertTriangle, cls: 'text-red-600 bg-red-50' },
  CASE_ESCALATED: { label: 'Rarifex coinvolto', Icon: LifeBuoy, cls: 'text-fuchsia-600 bg-fuchsia-50' },
  RARIFEX_INTERVENED: { label: 'Intervento di Rarifex', Icon: LifeBuoy, cls: 'text-fuchsia-600 bg-fuchsia-50' },
  SUPERADMIN_UPDATED_CASE: { label: 'Aggiornamento Rarifex', Icon: ShieldCheck, cls: 'text-fuchsia-600 bg-fuchsia-50' },
  CASE_RESOLVED: { label: 'Caso risolto', Icon: CheckCircle2, cls: 'text-emerald-600 bg-emerald-50' },
  CASE_REOPENED: { label: 'Caso riaperto', Icon: RotateCcw, cls: 'text-blue-600 bg-blue-50' },
  CASE_CLOSED: { label: 'Caso chiuso', Icon: Ban, cls: 'text-slate-600 bg-slate-100' },
  DEADLINE_APPROACHING: { label: 'Scadenza imminente', Icon: Clock, cls: 'text-amber-600 bg-amber-50' },
  DEADLINE_EXCEEDED: { label: 'Termine di risposta superato', Icon: Clock, cls: 'text-orange-600 bg-orange-50' },
};

export const OPEN_STATUSES = [
  'OPEN', 'WAITING_FOR_SELLER', 'WAITING_FOR_BUYER', 'IN_DISCUSSION',
  'SOLUTION_PROPOSED', 'WAITING_FOR_ACCEPTANCE', 'SELLER_RESPONSE_OVERDUE', 'ESCALATED_TO_RARIFEX',
];

export const isOpenCase = (status) => OPEN_STATUSES.includes(status);

export const formatMoney = (value) =>
  `€${Number(value || 0).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const formatDate = (iso, withTime = false) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString('it-IT', {
      day: 'numeric', month: 'short', year: 'numeric',
      ...(withTime ? { hour: '2-digit', minute: '2-digit' } : {}),
    });
  } catch { return iso; }
};

export const relativeDeadline = (iso) => {
  if (!iso) return null;
  const diff = new Date(iso).getTime() - Date.now();
  const days = Math.ceil(diff / 86400000);
  if (diff <= 0) return 'termine superato';
  if (days <= 1) return 'entro oggi';
  return `entro ${days} giorni`;
};

async function jsonFetch(url, options = {}) {
  // Il token serve alle rotte admin (require_admin); per le altre è ininfluente.
  const authHeader = await getAdminAuthHeader();
  const res = await fetch(url, {
    ...options,
    headers: { 'Content-Type': 'application/json', ...authHeader, ...(options.headers || {}) },
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : null;
  if (!res.ok) {
    throw new Error(data?.detail || 'Operazione non riuscita');
  }
  return data;
}

export const caseApi = {
  eligibility: (orderId) => jsonFetch(`${CASES_API}/eligibility/${orderId}`),
  list: (userId, role) => jsonFetch(`${CASES_API}?user_id=${userId}&role=${role}`),
  detail: (caseId, userId) => jsonFetch(`${CASES_API}/${caseId}?user_id=${userId}`),
  create: (payload) => jsonFetch(CASES_API, { method: 'POST', body: JSON.stringify(payload) }),
  sendMessage: (caseId, payload) =>
    jsonFetch(`${CASES_API}/${caseId}/messages`, { method: 'POST', body: JSON.stringify(payload) }),
  addAttachments: (caseId, userId, attachments) =>
    jsonFetch(`${CASES_API}/${caseId}/attachments?user_id=${userId}`, { method: 'POST', body: JSON.stringify(attachments) }),
  createProposal: (caseId, payload) =>
    jsonFetch(`${CASES_API}/${caseId}/proposals`, { method: 'POST', body: JSON.stringify(payload) }),
  respondProposal: (caseId, proposalId, payload) =>
    jsonFetch(`${CASES_API}/${caseId}/proposals/${proposalId}/respond`, { method: 'POST', body: JSON.stringify(payload) }),
  escalate: (caseId, payload) =>
    jsonFetch(`${CASES_API}/${caseId}/escalate`, { method: 'POST', body: JSON.stringify(payload) }),
  authorizeReturn: (caseId, userId) =>
    jsonFetch(`${CASES_API}/${caseId}/return/authorize?user_id=${userId}`, { method: 'POST' }),
  shipReturn: (caseId, payload) =>
    jsonFetch(`${CASES_API}/${caseId}/return/ship`, { method: 'POST', body: JSON.stringify(payload) }),
  returnReceived: (caseId, userId) =>
    jsonFetch(`${CASES_API}/${caseId}/return/received?user_id=${userId}`, { method: 'POST' }),
  requestRefund: (caseId, payload) =>
    jsonFetch(`${CASES_API}/${caseId}/refunds`, { method: 'POST', body: JSON.stringify(payload) }),
  cancel: (caseId, userId) => jsonFetch(`${CASES_API}/${caseId}/cancel?user_id=${userId}`, { method: 'POST' }),
  resolve: (caseId, userId) => jsonFetch(`${CASES_API}/${caseId}/resolve?user_id=${userId}`, { method: 'POST' }),
  upload: async (file) => {
    const form = new FormData();
    form.append('file', file);
    const res = await fetch(`${CASES_API}/upload`, { method: 'POST', body: form });
    const data = await res.json();
    if (!res.ok) throw new Error(data?.detail || 'Upload non riuscito');
    return data;
  },
};

export const adminCaseApi = {
  stats: () => jsonFetch(`${ADMIN_CASES_API}/stats`),
  list: (params = {}) => {
    const qs = new URLSearchParams(Object.entries(params).filter(([, v]) => v)).toString();
    return jsonFetch(`${ADMIN_CASES_API}${qs ? `?${qs}` : ''}`);
  },
  detail: (caseId) => jsonFetch(`${ADMIN_CASES_API}/${caseId}`),
  update: (caseId, payload) => jsonFetch(`${ADMIN_CASES_API}/${caseId}`, { method: 'PATCH', body: JSON.stringify(payload) }),
  message: (caseId, payload) => jsonFetch(`${ADMIN_CASES_API}/${caseId}/message`, { method: 'POST', body: JSON.stringify(payload) }),
  refund: (caseId, payload) => jsonFetch(`${ADMIN_CASES_API}/${caseId}/refund`, { method: 'POST', body: JSON.stringify(payload) }),
  reopen: (caseId, actorId) => jsonFetch(`${ADMIN_CASES_API}/${caseId}/reopen?actor_id=${actorId}`, { method: 'POST' }),
  checkDeadlines: () => jsonFetch(`${ADMIN_CASES_API}/check-deadlines`, { method: 'POST' }),
};
